import { validatePhoneInput, validateZipInput } from 'sidecar-utilities'
import { formTitles } from 'utils/memberComm/formTitles'

/**
 * Formik Form Validation Schema
 *
 * @param {object} values - An object containing form values.
 * @param {string} title - Title of the specific form
 * @param {number} expenses - Length of the expense dropdown when applicable
 * @returns {object} - An object containing form errors.
 */
export const validateRequestForm = (values, title, flags, expenses = 0) => {
  const {
    BENEFIT_AMOUNTS,
    COVERAGE,
    EXPENSE_QUESTION,
    INVOICE,
    IMPROVE_SEARCH_RESULTS,
    OTHER,
    PHARMACY_PLA,
    PROVIDER_PLA,
    SURGERY_SUPPORT,
  } = formTitles

  const errors = {}

  const errorMessages = {
    subject: 'Subject is required',
    selectedMember: 'Member is required',
    selectedExpense: 'Expense is required',
    drug: 'At least one prescription is required',
    message: 'Message is required',
    service: 'Procedure details are required',
    address: 'Facility info is required',
    issueType: 'Please select an issue type',
    provider: 'Provider name is required',
    practiceName: 'Practice name is required',
    providerSpecialty: 'Provider specialty is required',
    unit: 'Unit is required',
    city: 'City is required',
    state: 'State is required',
    zipRequired: 'Zip code is required',
    zipInvalid: 'Please enter a valid zip code',
    phoneRequired: 'Phone number is required',
    phoneInvalid: 'Please enter a valid phone number',
    website: 'Website is required',
  }

  switch (title) {
    case OTHER:
      if (!values.subject) {
        errors.subject = errorMessages.subject
      }
      if (!values.selectedMember) {
        errors.selectedMember = errorMessages.selectedMember
      }
      if (!values.message) {
        errors.message = errorMessages.message
      }
      return errors

    case EXPENSE_QUESTION:
      if (!values.subject) {
        errors.subject = errorMessages.subject
      }
      if (!values.selectedMember) {
        errors.selectedMember = errorMessages.selectedMember
      }
      if (!values.selectedExpense && expenses > 0) {
        errors.selectedExpense = errorMessages.selectedExpense
      }
      if (!values.message) {
        errors.message = errorMessages.message
      }
      return errors

    case PHARMACY_PLA:
      if (!values.selectedMember) {
        errors.selectedMember = errorMessages.selectedMember
      }
      if (!values.drug) {
        errors.drug = errorMessages.drug
      }

      if (!values.message) {
        errors.message = errorMessages.message
      }
      return errors

    // SURGERY_SUPPORT intake moved to the complex care MFE. It stays grouped
    // here for existing surgery requests, which only need a member and message.
    case BENEFIT_AMOUNTS:
    case COVERAGE:
    case INVOICE:
    case SURGERY_SUPPORT:
      if (!values.selectedMember) {
        errors.selectedMember = errorMessages.selectedMember
      }
      if (!values.message) {
        errors.message = errorMessages.message
      }
      return errors
    case IMPROVE_SEARCH_RESULTS:
      if (!values.issueType) {
        errors.issueType = errorMessages.issueType
      }
      if (!values.provider) {
        errors.provider = errorMessages.provider
      }
      if (!values.practiceName) {
        errors.practiceName = errorMessages.practiceName
      }
      if (!values.providerSpecialty) {
        errors.providerSpecialty = errorMessages.providerSpecialty
      }
      if (!values.address) {
        errors.address = errorMessages.address
      }
      if (!values.city) {
        errors.city = errorMessages.city
      }
      if (!values.state) {
        errors.state = errorMessages.state
      }
      if (!values.zip) {
        errors.zip = errorMessages.zipRequired
      } else if (validateZipInput(values.zip)) {
        errors.zip = errorMessages.zipInvalid
      }
      if (!values.phone) {
        errors.phone = errorMessages.phoneRequired
      } else if (validatePhoneInput(values.phone)) {
        errors.phone = errorMessages.phoneInvalid
      }
      if (!values.website) {
        errors.website = errorMessages.website
      }
      return errors

    case PROVIDER_PLA:
      if (!values.selectedMember) {
        errors.selectedMember = errorMessages.selectedMember
      }
      if (!values.message) {
        errors.message = errorMessages.message
      }
      if (!values.service) {
        errors.service = errorMessages.service
      }
      return errors
  }
}
